module.exports = __webpack_public_path__ + "img/spaceooh.3285f94b.png";